module.exports = __webpack_public_path__ + "img/barcelona_eixample.a514bd49.jpg";